module.exports = __webpack_public_path__ + "img/skinxs-orange-icon.54b14926.svg";